import { PanelDrawingDocument } from '../PanelDrawing/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  PanelDrawingCommentDocument,
  panelDrawingCommentPullQueryBuilder,
  panelDrawingCommentPushQueryBuilder,
} from './queryBuilder';

export function panelDrawingCommentsFamilyMember(
  configBuilder: ConfigBuilder,
  panelDrawing: FamilyMember<PanelDrawingDocument>,
): FamilyMember<PanelDrawingCommentDocument> {
  const syncConfig = configBuilder<PanelDrawingCommentDocument>(
    RxdbCollectionNameV2.PANEL_DRAWING_COMMENTS,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, panelDrawingCommentPullQueryBuilder);
  push(syncConfig, panelDrawingCommentPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.PANEL_DRAWING_COMMENTS, replicationState, [panelDrawing]);
}
